import { APICore } from '../../helpers/api/apiCore';
import * as URL from "../../helpers/api/apiEndPoint"

const api = new APICore();


function getTransactionHistory(params: any): any {
    const { uniqueId } = params.data
    return api.get(`${URL.GET_TRANSACTION_HISTORY}?uniqueId=${uniqueId}`);
}
function getDeletedTransactionHistory(params) {
    const { search, limit, pages } = params.data
    return api.get(`${URL.GET_DELETED_TRANSACTION_HISTORY}?limit=${limit}&page=${pages}`);
}
// search=${encodeURIComponent(search)}&

export { getTransactionHistory, getDeletedTransactionHistory }
